import { Collapse } from "antd";
import styled from "styled-components";
const { Panel } = Collapse;

export const RACollapse = ({ panel = {}, panels = [], size = "large", defaultActiveKey }) => {
	if (panels && panels.length > 0) {
		return (
			<Wrapper>
				<Collapse size={size} defaultActiveKey={defaultActiveKey}>
					{panels.map((item = {}) => {
						const { panelKey, panelHeader = "", content } = item;
						return (
							<Panel header={panelHeader} key={panelKey}>
								{content}
							</Panel>
						);
					})}
				</Collapse>
			</Wrapper>
		);
	}

	const { panelKey, panelHeader = "", content } = panel;
	return (
		<Wrapper>
			<Collapse size={size} defaultActiveKey={defaultActiveKey}>
				<Panel header={panelHeader} key={panelKey}>
					{content}
				</Panel>
			</Collapse>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	.ant-collapse {
		border: none !important;
		border-radius: 4px;
	}
	.ant-collapse .ant-collapse-content {
		border-top: none;
	}
	.ant-collapse > .ant-collapse-item {
		border-bottom: none;
	}
	.ant-collapse-large > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
		padding: 24px 0 0 0;
	}
`;
